import React, { useContext } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Heading5, Link, TableText } from '@qover/typography';
import { showChat } from '@qover/molecules';
import { BrokerContext, ZendeskChatContext } from '@qover/contexts';
import { customWindow } from '@qover/utils/src/customWindow';

const Container = styled.div`
  display: none;
  border-radius: 4px;
  background-color: var(--color-card-background-100);
  padding: 20px;
  > * + * {
    margin-top: 20px;
  }
  :first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    display: block;
  }
`;

function ChatIcon() {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M12.397 4.753a2.997 2.997 0 011.483.702c1.614 1.399 1.46 4.02-.307 5.206a4.156 4.156 0 01-.888.395c-.126.047-.16.09-.16.215v1.042a.53.53 0 01-.18.44.523.523 0 01-.724-.05c-.211-.207-.415-.42-.62-.63-.268-.272-.538-.541-.802-.816a.304.304 0 00-.243-.098c-.395.009-.79-.01-1.183-.057-.908-.154-1.57-.67-2.044-1.426-.086-.136-.011-.262.157-.262h.616c1.949-.024 3.354-.92 4.281-2.559.346-.622.55-1.31.6-2.017.003-.022.014-.045.014-.085zM7.44.125c1.578-.007 2.758.678 3.568 1.962a4.433 4.433 0 01-.697 5.522 3.94 3.94 0 01-2.8 1.086h-.866a.317.317 0 00-.255.103c-.65.667-1.305 1.33-1.95 1.995a.656.656 0 01-.489.224.592.592 0 01-.418-.173.563.563 0 01-.165-.413V8.773c0-.106-.03-.147-.14-.167C1.63 8.205.655 7.188.181 5.678A8.31 8.31 0 010 4.813v-.802c.029-.255.08-.508.15-.755C.541 1.868 1.384.863 2.788.34A3.617 3.617 0 014.05.125H7.44z"
        fill="currentColor"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M9 11c-1 0-2-1-3-2S4 7 4 6s1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8 1.945 1.945 6 4 8 4 0 0 3-2 3-3s-3-4-4-3-1 2-2 2z"
        fill="currentColor"
      />
    </svg>
  );
}

const ContactList = styled.ul`
  list-style: none;
  svg {
    margin-right: 8px;
  }
`;
const ContactListItem = styled.li`
  margin-top: 10px;
  display: flex;
  align-items: center;
`;

interface ContactProps {
  containerStyle?: React.CSSProperties;
}

export function Contact(props: ContactProps) {
  const zendesk = useContext(ZendeskChatContext);
  const broker = useContext(BrokerContext);
  const phone = broker?.informations?.general?.phone ?? '';
  return (
    <Container id="help" style={props.containerStyle}>
      <Heading5 as="div">
        <Trans id="general.summary.needHelp" />
      </Heading5>
      <TableText as="div">
        <ContactList>
          <ContactListItem>
            <Link className="bold" href={`tel:${phone}`}>
              <PhoneIcon />
              {phone}
            </Link>
          </ContactListItem>
          <ContactListItem>
            <Link
              className="bold"
              href="#show-chat"
              onClick={() =>
                !customWindow.$zopim
                  ? zendesk.setInitializeZendesk?.(true)
                  : showChat()
              }
            >
              <ChatIcon />
              <Trans id="general.startChat" />
            </Link>
          </ContactListItem>
        </ContactList>
        <Trans id="general.summary.openingHours" />
      </TableText>
    </Container>
  );
}
